import commonHelper from '@/app/utility/common.helper.utility';
// import appStrings from '@/app/utility/string.utility';
import URL_UTILITY from '@/app/utility/url.utility';
import DatePicker from 'vue2-datepicker';
export default {
  name: 'updateCalibration',
  components: {
    DatePicker
  },
  props: ['historyRowData'],
    watch: {
      selectAllCheckBox: function () {
        this.checkUncheckAll();
      }
    },
  data() {
    return {
      uploadCalibrationModal: false,
      isSuccess: false,
      showAlert: false,
      respMessage: null,
      editMode: false,
      payload: null,
      unsubscribe: null,
      loader: false,
      machineCode: null,
      machineName: null,
      modelNo: null,
      serialNo: null,
      docNo: null,
      bookTypeCode: null,
      manufacturer: {
        text: null,
        value: null
      },
      locCostCenter: {
        text: null,
        value: null
      },
      calFreq: {
        text: null,
        value: null
      },
      status: {
        text: null,
        value: null
      },
      departUser: {
        text: null,
        value: null
      },
      capacity: null,
      accuracyReso: null,
      installDate: null,
      lastCalDate: null,
      nextCalDueDate: null,
      calCerExpiryDate: null,
      noteComments: null,
      hsnCode: null,
      vendorName: null,
      itemCode: null,
      poNum: null,
      historyData: [
        {
          exp_date: null,
          calib_date: null,
          file_name: null,
          doc_id: null,
          doc_detail_id: null,
          uploadedDocId: null
        }
      ],
      historyFields: [
        {
          key: 'selectBox',
          label: 'Select',
          stickyColumn: true,
          variant: 'primary'
        },
        {
          key: 'location_name',
        },
        {
          key: 'creation_date',
          label: 'Receive Date'
        },
        {
          key: "calib_date",
          label: 'Calibration Due Date'
        },
        {
          key: "exp_date",
          label: 'Calibration Expiry Date'
        },
        {
          key: "file_name",
        },
        {
          key: "save_document",
        },
        // {
        //   key: 'remove',
        //   stickyColumn: true
        // },
      ],
      openkmAuthToken: null,
      fileName: null,
      docId: null,
      downloadDocUrl: URL_UTILITY.getOpenKmDocDeleteUrl,
      selectedFilesArr: [],
      currentIndex: 0,
      specIndex: null,
      selectAllCheckBox: false
    };
  },
  mounted() {
    if (this.historyRowData) {
      this.filledDataParentToChild(this.historyRowData)
    }
    this.getHistoryDataById();
    this.getOpenKmAuthToken();
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'save' && this.editMode) {
          this.addEditHistoryDetail();
        } else if (actionName === 'update') {
          this.editMode = true;
        } else if (actionName === 'delete') {
          this.deleteDocument();
        }
      }
    });
  },
  methods: {
    checkUncheckAll() {
      this.historyData = this.historyData.map(data => {
        data.selectBox = data.doc_id && this.selectAllCheckBox;
        return data;
      });
    },
    selectBoxChecked(flag, index) {
      this.selectedIndex = index;
      this.historyData[index].selectBox = flag;
    },
    deleteDocument() {
      const filterData = this.historyData.filter(data => data.selectBox);
      if (filterData.length) {
      const deleteDoc = filterData.map(elem => {
        return {
          doc_ids_del: elem.doc_id
        };
      });
      const payload = {
        doc_ids: deleteDoc ? deleteDoc : null
      };
        this.loader = true;
        this.$store
          .dispatch('weighMachine/deleteDocument', payload)
          .then(response => {
              this.loader = false;
              this.showAlert = true;
            if (response.status === 200) {
              this.getHistoryDataById();
              this.selectAllCheckBox = false;
              this.historyData[this.selectedIndex].file_name = null;
              this.historyData[this.selectedIndex].doc_id = null;
              this.editMode = false;
              this.isSuccess = true;
              this.respMessage = response.data.message;
            } else {
              this.isSuccess = false;
              this.respMessage = response.response.data.message;
            }
            })
          .catch(() => {
              this.loader = false;
              // this.showAlert = true;
              // this.isSuccess = false;
              // this.respMessage = appStrings.autoFailedMsg;
              });
          } else {
            alert('Please Select Document');
          }
        },
    removeRow(index, docDetailId){
      const payload = {
        docDetailId: this.docId ? this.docId : docDetailId,
        token: this.openkmAuthToken
      };
      if (docDetailId !== 0) {
        this.loader = true;
        this.$store
          .dispatch('intWorkflow/delteOpenKmDoc', payload)
          .then(response => {
            this.loader = false;
            this.showAlert = true;
            if (response.status === 200) {
              this.editMode = false;
              this.isSuccess = true;
              this.respMessage = response.data.message;
              this.historyData[index].file_name = null;
            } else {
              this.isSuccess = false;
              this.respMessage =
                response.response.data.message || 'Something went wrong';
            }
          })
          .catch(() => {
            this.loader = false;
          });
      } else {
        this.historyData[index].file_name = null;
      }
    },
    calibDueDateIndex(index) {
      this.specIndex = index;
      this.historyData[index].exp_date = null;
    },
    expDateIndex(index) {
      this.specIndex = index;
    },
    disabledDates(date) {
      return commonHelper.disabledDates(date, this.historyData[this.specIndex].calib_date);
    },
    calibDisabledDates(date) {
      // return commonHelper.disabledDates(date, this.installDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date < today;
    },
    filledDataParentToChild(item) {
      this.serialNo = item.serial_no;
      this.modelNo = item.model_no;
      this.modelNo = item.model_no;
      this.docNo = item.doc_num;
      this.accuracyReso = item.accuracy_resolution;
      this.bookTypeCode = item.book_type_code;
      this.calCerExpiryDate = item.calibration_certificate_expiry_date;
      this.calFreq.text = item.calibration_frequency;
      this.capacity = item.capacity_unit;
      // this. = item.current_flag
      this.departUser.text = item.department_user_responsible;
      this.machineName = item.description;
      this.hsnCode = item.hsn_sac_code;
      this.installDate = item.installation_date;
      this.lastCalDate = item.last_calibration_date;
      this.locCostCenter.text = item.location_name;
      this.machineCode = item.item_code;
      this.machineName = item.description;
      this.manufacturer.text = item.manufacturer_name;
      this.nextCalDueDate = item.next_calibration_due_date;
      this.noteComments = item.notes_comments;
      this.status.text = item.status;
      this.vendorName = item.vendor_name;
      this.poNum = item.po_number;
      this.itemCode = item.item_code;
    },
    browseFile(index) {
      // this.$refs.file.click();
      const fileInputRef = this.$refs[`file-${index}`];
      if (fileInputRef) {
        const fileInput = Array.isArray(fileInputRef) ? fileInputRef[0] : fileInputRef;
        if (fileInput) {
          fileInput.click();
        }
      }
    },
    selectFile(data, event) {
      // this.$refs.file.files[0].name;
      // const file = event.target.files[0];
      // if (file) {
      //   this.$set(data.item, 'file_name', file.name);
      //   this.$set(data.item, 'file', file);
      // }
      const files = event.target.files;
      if (files && files.length > 0) {
        const file = files[0];
        this.$set(data.item, 'file_name', file.name);
        this.$set(data.item, 'file', file);
      }
    },
    removeFile(data) {
      this.$set(data.item, 'file_name', '');
      this.$set(data.item, 'file', null);
      const fileInputRef = this.$refs[`file-${data.index}`];
      if (fileInputRef) {
        const fileInput = Array.isArray(fileInputRef) ? fileInputRef[0] : fileInputRef;
        if (fileInput) {
          fileInput.value = '';
        }
      }
    },
    checkOpenKmPasswordSaved(item, index) {
      this.currentIndex = index;
      // to check password save or not
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/checkSavedPassword')
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            if (response.data.data) {
              this.getOpenKmAuthToken(item);
            }
            //  else {
            //   this.showHideOpenKmModal(true);
            // }
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getOpenKmAuthToken(item) {
      // to get auth token for open km
      const payload = {
        password: null,
        saved_password_flag: true,
        user_name: null
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/openKmAuthenticate', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.openkmAuthToken = response.data.data.token;
            this.uploadFile(item)
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    uploadFile(item) {
      let formData = new FormData();
      // formData.append('file', this.$refs.file.files[0]);
      formData.append('file', item.file);
      formData.append('token', this.openkmAuthToken);
      formData.append('category', null);
      formData.append('sub_category', null);
      formData.append('comment', null);
      formData.append('doc_detail_id', 0);
      formData.append('menu_id', this.$store.state.shared.menuId);
      formData.append('sub_menu_id', 0);
      formData.append('le_id', null);
      formData.append('record_id', item.seq_id);
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/uploadOpenKmDoc', formData)
        .then(response => {
          this.loader = false;
          this.showAlert = true;
          if (response.status === 200) {
            this.fileName = response.data.data.original_file_name;
            this.docId = response.data.data.doc_detail_id;
            this.historyData[this.currentIndex].file_name = response.data.data.original_file_name;
            this.historyData[this.currentIndex].uploadedDocId = response.data.data.doc_detail_id;
            this.editMode = true;
            this.isSuccess = true;
            this.respMessage = response.data.message;
          } else {
            this.isSuccess = false;
            this.respMessage = response.response.data.message || 'Something went wrong';
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getHistoryDataById() {
      const payload = {
        asset_id: this.historyRowData.asset_id
      }
      this.loader = true;
      this.$store
        .dispatch('weighMachine/getHistoryDataById', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const item = resp.data.data.page;
            this.historyData = item;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    addEditHistoryDetail() {
      if(this.historyData[0].file_name){
      const filterData = this.historyData.filter(ele =>
        !ele.calib_date ||
        !ele.exp_date 
        // || !this.historyData[0].uploadedDocId
        // || !this.docId
      );
      if (filterData.length) {
        alert('Kindly Fill Details Mandatory Fields.')
      }
      else {
        const uploadHistory = this.historyData.map(ele => {
          return {
            datecalib: ele.calib_date,
            doc_id: ele.uploadedDocId ? ele.uploadedDocId : ele.doc_id,
            exp_date: ele.exp_date,
            file_name: ele.file_name,
            asset_id: ele.asset_id,
            seq_id: ele.seq_id
          };
        });
        const payload = {
          doc: uploadHistory ? uploadHistory : null
        }
        // const payload = {
        //   datecalib: this.historyData[0].calib_date,
        //     doc_id: this.docId,
        //     exp_date: this.historyData[0].exp_date,
        //     file_name: this.fileName,
        //     asset_id: this.historyData[0].asset_id,
        //     seq_id: this.historyData[0].seq_id
        // }; 
        this.loader = true;
        this.$store
          .dispatch('weighMachine/addEditHistoryDetail', payload)
          .then(response => {
            this.loader = false;
            this.showAlert = true;
            if (response.status === 200) {
              this.editMode = false;
              this.isSuccess = true;
              this.respMessage = response.data.message;
              this.getHistoryDataById();
            } else {
              this.isSuccess = false;
              this.respMessage = response.response.data.message;
            }
          })
          .catch(() => {
            this.loader = false;
          });
        }}
        else {
          alert('Please Upload Document!')
        }
    },
  },
  beforeDestroy() {
    clearTimeout(this.setTimeVsetCode);
    this.unsubscribe();
  }
};
